
export function HandleRingpool() {

    const observer = new MutationObserver(() => {
        const botoneraBottom = document.getElementsByClassName("botonera")[0];
        const dateTimeContainer = document.getElementsByClassName("date_text")[0];

        const ELIMINAMOS_RINGPOLL_EMERGENCIA = false; //Caso de emergencia se pone en true

        const hourActuali = new Date();
        const hourStart = 9;
        const hourEnd = 21;
        const Saturday = hourActuali.getDay() == 6 && hourActuali.getHours() >= hourStart && hourActuali.getHours() <= 13;

        if (dateTimeContainer && Saturday && (window.site == "coche" || window.site == "moto" || window.site == "hogar")) {
            dateTimeContainer.innerHTML = "L - V 9:00 - 22:00h | S 9:00-14:00h";
            observer.disconnect();
            return;
        };

        if (ELIMINAMOS_RINGPOLL_EMERGENCIA) {
            botoneraBottom.style.display = "none";
            observer.disconnect();
        } else if (botoneraBottom) {
            observer.disconnect();
            if (hourActuali.getHours() < hourStart || hourActuali.getHours() >= hourEnd || window.site == "vida" || hourActuali.getDay() == 0 || hourActuali.getDay() == 6) {
                botoneraBottom.style.display = "none";
            }
        }

    });

    observer.observe(window.document, { childList: true, subtree: true });
}